module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/337.95c59d32.png";